export default "__VITE_ASSET__BDirbxfr__"